import { render, staticRenderFns } from "./EditBarang.vue?vue&type=template&id=49da4e28&"
import script from "./EditBarang.vue?vue&type=script&lang=js&"
export * from "./EditBarang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports